/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type AppService from 'embercom/services/app-service';

// Pass-through route for /ask/:chat_id — React Router handles the rendering.
export class AskChatRoute extends Route {
  @service declare appService: AppService;

  reactEnabled() {
    return this.appService.app.canUseStandalone;
  }
}

export default ReactRoute(AskChatRoute);
